import { useAgentManager } from '../providers/AgentProvider';

export const useWorkspaceId = () => {
  const { workspaceId } = useAgentManager();

  return { workspaceId };
};
